import { useEffect, useState } from "react";
import EventBox from "./event_box";
import { API_STATUS } from "../../constants";
import { GetSevedEvents } from "../../apis/event/get_saved_event";
import PlaceHolder from "../../utils/placeholder";

export default function SavedEventWrap() {

    const [GetEventApi, setGetEventApi] = useState(API_STATUS);
    const [EventData, setEventData] = useState([]);
    const [NoData, setNodata] = useState(false);

    useEffect(() => {
        GetSevedEvents(setGetEventApi);
    }, []);

    useEffect(() => {
        if (!GetEventApi.isError && !GetEventApi.isLoader && GetEventApi.data != null) {
            let res = GetEventApi.data;
            if (res['status'] === 1) {
                setEventData(res['data']);
            } else {
                setNodata(true);
            }
        }
    }, [GetEventApi]);

    return <div className="md:max-w-[510px] mx-auto flex-1 xl:space-y-6 space-y-3">
        {
            GetEventApi.isLoader &&
            <PlaceHolder />
        }
        {
            EventData !== null && EventData.length > 0 &&
            <div className="flex-1 xl:space-y-6 space-y-3">
                {
                    EventData.map((item) =>
                        <EventBox key={item.e_id} item={item} detail={false} esave={1} />
                    )
                }
            </div>
        }

    </div>
}